import { onActivated, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useFrontCmsStore, type FrontCmsKey } from '../stores/frontCms';

function loadFrontCmsKeys(store: ReturnType<typeof useFrontCmsStore>, keys: FrontCmsKey[]) {
  if (!keys.length) {
    return;
  }
  store.hydrateFromCache();
  void store.ensureMany(keys);
}

/**
 * 在页面中加载指定 CMS 数据集：先展示缓存，后台与接口比对后按需更新。
 */
export function useFrontCms(...keys: FrontCmsKey[]) {
  const store = useFrontCmsStore();

  // 进入页面立即拉取（不等 onMounted），避免仅依赖 App 首次 bootstrap
  loadFrontCmsKeys(store, keys);

  onMounted(() => {
    loadFrontCmsKeys(store, keys);
  });

  onActivated(() => {
    loadFrontCmsKeys(store, keys);
  });

  return {
    store,
    ...storeToRefs(store)
  };
}

/**
 * 应用壳层初始化：从本地恢复全部缓存并后台刷新。
 */
export function bootstrapFrontCms() {
  const store = useFrontCmsStore();
  store.hydrateFromCache();
  void store.refreshAll();
}
